<template>
    <div id="url_valid">
        <div id="border">
            <div class="survey-forms">
                <div class="row ">
                  <div class="col-xs-12 col-sm-12 col-md-12"></div>
                  <div class="col-xs-12 col-sm-12 col-md-12 survey-form" :style="{ 'background-image': 'url(' + bgImage + ')' }"  v-show="!formSubmit">
                    <div class="survey-content"> 
                      <div class="form-layout">
                        <p id="top-para">Happy Milk Index(HMI) is an index created by Doodhvale to measure the happiness index of the milk you are consuming.  It is proven that a happier milk is a healthier milk.</p>
                        <p id="question_para">Please answer the following questions to find out your milk’s HMI score : </p>
                        <form>
                          <b-field label="Name">
                            <b-input 
                              v-model="name" 
                              name="name" 
                              type="text" 
                              placeholder="Name" 
                              style="width: 100%; height: 50px;" 
                            />
                          </b-field>
                          <b-field label="Mobile Number">
                            <b-input
                              v-model="mobile_no"
                              type="text" 
                              name="mobile"
                              id="mobile"
                              placeholder="Mobile Number"
                              oninput="this.value=this.value.replace(/[^0-9]/g,'');"
                              style="width: 100%; height: 50px;"
                            />
                          </b-field>
                          <span class="errormsg" v-if="error_mob.length>0">{{error_mob}}
                          </span>
                          <b-field label="Address">
                            <b-input
                              type="text" 
                              v-model="address"
                              name="address"
                              placeholder="Address"
                              style="width: 100%; height: 50px;" 
                            />
                          </b-field>
                          <b-field label="Pin Code">
                            <b-input
                              id = "pincode"
                              type="text" 
                              v-model="pin_code"
                              name="pincode"
                              placeholder="Pin Code"
                              oninput="this.value=this.value.replace(/[^0-9]/g,'');"
                              style="width: 100%; height: 50px;" 
                            />
                          </b-field> 
                          <span class="errormsg" v-if="error_pin.length>0">{{error_pin}}
                          </span>                       
                        </form>
                      </div>
                      <div class="card-layout" v-for="questionObj in questionArray" v-bind:key="questionObj.id">
                        <div class="card-view">
                          <div class="question" :id="questionObj.id">
                            {{questionObj.questions}}
                          </div>
                          <div class="answer row">
                            <div class="col-xs-4 col-sm-4 col-md-4"> 
                              <b-radio v-model="questionObj.answer"
                                native-value=1>
                                Yes
                              </b-radio>
                            </div>
                            <div class="col-xs-4 col-sm-4 col-md-4">
                              <b-radio v-model="questionObj.answer"
                                native-value=0>
                                No
                              </b-radio>
                            </div>
                            <div class="col-xs-4 col-sm-4 col-md-4">
                              <b-radio v-model="questionObj.answer"
                                native-value=-1>
                                Don't Know
                              </b-radio>
                            </div>
                          </div>
                          <span class="errormsg" :id="'err_'+ questionObj.id">
                        </span>
                        </div>
                      </div>
                      
                      <div class="text-center submit-btn">
                        <b-button rounded=true type="is-primary" size="is-medium" class="btn btn-primary rounded" @click="saveFormDetails">CHECK SCORE</b-button>
                      </div>
                      <p id="disclaimer">*Happy Milk Index is an index made and managed by Doodhvale itself to maintain their milk’s quality standards. HMI is not an industry standard metric and is not accredited by any of the certified bodies.</p>
                    </div>
                  </div>
                  <div class="col-xs-12 col-sm-12 col-md-12 survey-result" v-show="formSubmit">
                    <img :src="getImage()" class="result-image"/>
                    <div class="succes-button">
                      <b-button rounded=true type="is-primary" size="is-medium" class="btn btn-primary rounded" @click="downloadApp">Download App</b-button>
                    </div>
                  </div>
                  <div class="col-xs-12 col-sm-12 col-md-12"></div>
                </div>
              <div>
            </div>
        </div>
        <loading :active.sync="isLoading" 
        :is-full-page="fullPage" :color="'#FFDE00'"></loading>
      </div>
     
    </div>
</template>
<script>
  import ChartCard from 'src/components/UIComponents/Cards/ChartCard.vue'
  import StatsCard from 'src/components/UIComponents/Cards/StatsCard.vue'
  import Card from 'src/components/UIComponents/Cards/Card.vue'
  import LTable from 'src/components/UIComponents/Table.vue'
  import Checkbox from 'src/components/UIComponents/Inputs/Checkbox.vue'
  import axios from 'axios'
  import Loading from 'vue-loading-overlay'
  import 'vue-loading-overlay/dist/vue-loading.css'
  export default {
    components: {
      Checkbox,
      Card,
      LTable,
      ChartCard,
      StatsCard,
      Loading
    },
    data () {
      return {
        error_msg: '',
        error_mob: '',
        error_pin: '',
        fullPage: true,
        isLoading: false,
        isActive: false,
        errors: '',
        name: '',
        mobile_no: '',
        address: '',
        pin_code: '',
        form_no: '1',
        surveyResult: [],
        backgroundUrl: '',
        formSubmit: false,
        bgImage: 'https://www.doodhvale.com/hmi_images/bg.jpg',
        questionArray: [
          {
            id: 1,
            questions: '1. Does your milk brand provide at least 150sq ft of average space per cattle (sufficient enough for them to roam and recreate)?',
            answer: ''
          },
          {
            id: 2,
            questions: '2. Is the cattle kept untied all the time?',
            answer: ''
          },
          {
            id: 3,
            questions: '3. Is your milk’s farm well equipped with stress relievers like brushes, fans and cooling system for the mental and physical well-being of the Cattle?',
            answer: ''
          },
          {
            id: 4,
            questions: '4. Is the cattle kept together for companionship and socialising?',
            answer: ''
          },
          {
            id: 5,
            questions: '5. Does your milk brand encourage regular farm visits from outsiders?',
            answer: ''
          },
          {
            id: 6,
            questions: '6. Do they treat cattle like their family by naming them, celebrating their birthdays, etc ?',
            answer: ''
          },
          {
            id: 7,
            questions: '7. Is the cattle given optimum exposure to sunlight for a better synthesis of Vitamin D3?',
            answer: ''
          },
          {
            id: 8,
            questions: '8. Easy access to clean drinkable water for the cattle?(Within 50ft.)',
            answer: ''
          },
          {
            id: 9,
            questions: '9. Is each cattle given personalised feed & supplements to match their nutritional requirement?',
            answer: ''
          },
          {
            id: 10,
            questions: '10. Are there regular cattle health checkups & vaccinations?',
            answer: ''
          }
        ]
      }
    },
    created () {
      this.fetchData()
    },
    methods: {
      fetchData () {
      },
      getImage () {
        let imagePath = ''
        switch (this.surveyResult.length) {
          case 0:
            imagePath = 'https://www.doodhvale.com/hmi_images/0.jpg'
            break
          case 1:
            imagePath = 'https://www.doodhvale.com/hmi_images/1.jpg'
            break
          case 2:
            imagePath = 'https://www.doodhvale.com/hmi_images/2.jpg'
            break
          case 3:
            imagePath = 'https://www.doodhvale.com/hmi_images/3.jpg'
            break
          case 4:
            imagePath = 'https://www.doodhvale.com/hmi_images/4.jpg'
            break
          case 5:
            imagePath = 'https://www.doodhvale.com/hmi_images/5.jpg'
            break
          case 6:
            imagePath = 'https://www.doodhvale.com/hmi_images/6.jpg'
            break
          case 7:
            imagePath = 'https://www.doodhvale.com/hmi_images/7.jpg'
            break
          case 8:
            imagePath = 'https://www.doodhvale.com/hmi_images/8.jpg'
            break
          case 9:
            imagePath = 'https://www.doodhvale.com/hmi_images/9.jpg'
            break
          case 10:
            imagePath = 'https://www.doodhvale.com/hmi_images/10.jpg'
            break
        }
        return imagePath
      },
      downloadApp () {
        this.$router.push({path: '/a/appLink'})
      },
      saveFormDetails () {
        let self = this
        this.isLoading = true
        if (this.mobile_no !== '') {
          if (this.mobile_no.length !== 10) {
            this.error_mob = 'Please Enter 10-digit Mobile Number'
            this.isLoading = false
            this.isActive = true
            setTimeout(() => {
              this.error_mob = ''
            }, 3000)
            document.getElementById('mobile').focus()
            return
          }
        }
        if (this.pin_code !== '') {
          if (this.pin_code.length !== 6) {
            this.error_pin = 'Please Enter 6-digit Pin Code'
            this.isLoading = false
            this.isActive = true
            setTimeout(() => {
              this.error_pin = ''
            }, 5000)
            return
          }
        }
        let surveyResult = self.questionArray.filter(x => x.answer === '')
        if (surveyResult.length !== 0) {
          let errNo = surveyResult[0].id
          let errDiv = document.getElementById(errNo)
          errDiv.scrollIntoView()
          document.getElementById('err_' + errNo).innerHTML = 'Please fill answers for the questions'
          // this.error_msg = 'Please fill answers for all the questions'
          this.isLoading = false
          setTimeout(() => {
            document.getElementById('err_' + errNo).innerHTML = ''
          }, 3000)
          return
        }
        let postData = JSON.stringify(self.questionArray)
        const params = new URLSearchParams()
        params.append('form_no', self.form_no)
        params.append('phone_no', self.mobile_no)
        params.append('name', self.name)
        params.append('pincode', self.pin_code)
        params.append('questions_json', postData)
        params.append('address', self.address)
        axios({
          url: process.env.BASE_API + '/users/survey-data',
          method: 'post',
          data: params,
          withCredentials: false,
          headers: {
          }
        }).then(response => {
          if (response.data.status === '000000') {
            self.surveyResult = self.questionArray.filter(x => x.answer === '1')
            this.isLoading = true
            setTimeout(() => {
              this.isLoading = false
            }, 5000)
            self.formSubmit = true
          } else {
            this.error_msg = response.data.msg
            setTimeout(() => {
              this.error_msg = ''
            }, 5000)
            // setTimeout(function() { self.openToast(response.data.msg, 'danger') }, 200)
          }
        })
        .catch(e => {
          this.error_msg = e
          // setTimeout(function() { self.openToast(e, 'danger') }, 200)
          // console.log(e)
        })
        self.isLoading = false
      }
    }

  }
</script>
<style>
  body, h1, .h1, h2, .h2, h3, .h3, h4, .h4, h5, .h5, h6, .h6, p, .navbar, .brand, .btn-simple, .alert, a, .td-name, td, button.close{
    font-family: sans-serif;
  }
.wrapper{text-align: left !important;}
.label {
    color: #8b8c8c;
    font-size: 15px;
  }

#question_para{
margin-top: 25%;

}
#question_para,#disclaimer,#top-para{
font-size: medium;
font-family: sans-serif;
color: #5e6363;
}
#disclaimer{
  font-size: 12px;
}
#top-para{
  color:white;
}
.card-view{
  margin: 5% auto;
  border: #d0c9c9 1px solid;
  border-radius: 10px;
  padding: 10px;
  background-color: white;
  text-align:left;
  font-size:medium;
  /* s */
}
 .result-image{
  height: auto;
  width: 100%;
} 
.succes-button{
  margin-top: -15%;
  padding: 10px;
  text-align: center;
}
/*.survey-result {
  display: none;
}*/
.survey-form{
  background-size: cover;
  /* background-size: 411px 1893px;
   background: url("https://www.doodhvale.com/hmi_images/bg.jpg"); */
}
.survey-content{
  padding-top: 45%;
  /*padding-bottom: 20px;
  padding-left: 20px;
  padding-right: 20px;*/
  color: #5e6363;
}
.card-layout .card-view{
  box-shadow:#d0c9c9 !important;
}
.form-layout{
  margin-left: auto;
  margin-right: auto;
}
.form-layout form{
  width:100%;
}
.errormsg {
  color: #da4c4c;
  /*border: 1px solid #da4c4c;
  border-radius: 10px;*/
  padding: 5px;
}
.answer div {
  text-align: left !important;
}
.submit-btn {
  padding: 10px;
  padding-bottom: 20px;
}
.card-view{
  width:100%;
  }

  p {
    font-size: 15px;
  }

.rounded {
  border-radius: 1.25rem !important;
}
.btn{font-weight: 600;}

.btn-primary {
    border-color: #3472F7;
    background-color: #3472f7;
    color: white;
  }

@media screen and (max-width: 768px)  {
  .survey-content{
    padding-top: 45%;
  }
  .survey-form{
   background-position-x: center;
    background-position-y: center;
    background-repeat: no-repeat;
    background-size: 100% 105%;
    left: 0;
    position: absolute;
    right: 0;
    top: 0;
  }

}

@media screen and (max-width: 400px)  {
  .survey-content{
    padding-top: 55%;
  }
  .survey-form{
   background-position-x: center;
    background-position-y: center;
    background-repeat: no-repeat;
    background-size: 100% 105%;
    left: 0;
    position: absolute;
    right: 0;
    top: 0;
  }

}
</style>


// WEBPACK FOOTER //
// src/components/Dashboard/Views/Hmi.vue